module.exports = __webpack_public_path__ + "static/media/oh_pack3_sample011_0001.d0939523.png";